import React, { useMemo } from 'react';
import Section from '~/App/shared/components/Layout/Section';
import { useSelector } from 'react-redux';
import { HitAndSorting } from '~/App/views/FilterPage/components/HitAndSorting';
import styled from 'styled-components';
import { PromoSettingCMSData } from '~/App/shared/interfaces/PromoSettingCMSData';
import ObjectListContainer from '../../FilterPage/components/ObjectListContainer';
import { hitsSelector } from '~/App/shared/selectors/storeObjectsSelectors';
import { useLocation } from 'react-router-dom';
import { CombinedMainCategory } from '~/App/shared/types/MainCategoryTypes';
import { localizationSelector } from '~/App/shared/selectors/localization';
import { isExportDomain } from '~/App/shared/localization/helpers';

const HitAndSortingWrapper = styled.div`
  margin: 1rem 0;
`;

interface Props {
  queryString: string;
  promoSettingsData?: PromoSettingCMSData;
  mainCategory?: CombinedMainCategory;
}

const ObjectsList = ({
  queryString,
  promoSettingsData,
  mainCategory
}: Props) => {
  const { search } = useLocation();
  const { domainLocale } = useSelector(localizationSelector);

  const searchQuery = useMemo(() => {
    const searchParams = new URLSearchParams(search);
    const queryStringParams = new URLSearchParams(queryString);

    // merge query string params with search params
    queryStringParams.forEach((value, key) => {
      searchParams.set(key, value);
    });

    if (isExportDomain(domainLocale)) {
      searchParams.set('exportable', 'true');
    }

    if (!searchParams.has('orderBy')) {
      searchParams.append('orderBy', '-grade');
    }

    return searchParams.toString();
  }, [queryString, search, domainLocale]);

  const hits = useSelector(hitsSelector(searchQuery));

  return (
    <Section
      data-testid="objects-list"
      maxWidth={64}
      spacingTop={0}
      spacingBottom={2}
    >
      <HitAndSortingWrapper>
        <HitAndSorting hits={hits} />
      </HitAndSortingWrapper>
      <ObjectListContainer
        searchQuery={searchQuery}
        promoSettingsData={promoSettingsData}
        mainCategory={mainCategory}
      />
    </Section>
  );
};

export default ObjectsList;
